import React from "react";
import { cn } from "../../lib/utils";

export function Divider({ variant = "simple", className }) {
  if (variant === "simple") {
    return (
      <hr
        className={cn(
          "border-0 h-px",
          "bg-gradient-to-r from-transparent via-border-dark to-transparent",
          "my-8",
          className
        )}
      />
    );
  }

  if (variant === "double") {
    return (
      <div className={cn("my-8 space-y-1", className)}>
        <hr className="border-0 h-px bg-border-dark" />
        <hr className="border-0 h-px bg-border-dark" />
      </div>
    );
  }

  if (variant === "deco") {
    return (
      <div className={cn("deco-divider", className)}>
        <div className="deco-divider-ornament" />
      </div>
    );
  }

  // Ornate variant - Art Deco style with geometric elements
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-4 my-10",
        className
      )}
    >
      {/* Left line */}
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border-dark to-border-dark" />

      {/* Center ornament - Art Deco diamond */}
      <div className="relative flex items-center gap-2">
        <div className="w-2 h-2 bg-gold rotate-45" />
        <div className="w-3 h-3 border-2 border-gold rotate-45" />
        <div className="w-2 h-2 bg-gold rotate-45" />
      </div>

      {/* Right line */}
      <div className="flex-1 h-px bg-gradient-to-l from-transparent via-border-dark to-border-dark" />
    </div>
  );
}

// Section header with built-in divider
export function SectionHeader({ title, subtitle, className }) {
  return (
    <div className={cn("text-center mb-12", className)}>
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-ink tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 text-ink-muted font-body text-lg max-w-2xl mx-auto">
          {subtitle}
        </p>
      )}
      <Divider variant="ornate" className="mt-6" />
    </div>
  );
}
